export default function contactNumber() {
  return window ? window.contactNumber : '';
}
